import { useContext } from "react";
import { TaskFileUploadContext } from "..";

export const useTaskFileUploadContext = () => useContext(TaskFileUploadContext);
